export const fontsArray =   [
{ value: "STANDARD", label: "STANDARD" },
{ value: "BEBAS KAI", label: "BEBAS KAI" },
{ value: "HORSEBACK", label: "HORSEBACK" },
{ value: "PRIMETIME", label: "PRIMETIME" },
{ value: "CHUNK FIVE", label: "CHUNK FIVE"}
]